jQuery(document).ready(function($ = jQuery) {
    $('.jd-filter').select2({
		dropdownParent: $('#jd-filters'),
	}).on('change', function(e) {
		$('#jd-clear-filters').addClass('clear-active');
	});

	$('.select2-selection--multiple .select2-search__field').on('keyup', function(e) {
		if(e.target.value.length > 0) {
			$(e.target).parent().parent().addClass('active');
		} else {
			$(e.target).parent().parent().removeClass('active');
		}
	});

	$('#finance').on('change', function(e) {

		let min_label = 'Min Price';
		let max_label = 'Max Price';
		let min_options = '';
		let max_options = '';

		var formatter = new Intl.NumberFormat('en-GB', {
			style: 'currency',
			currency: 'GBP',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0,
		});

		//if the user has chosen to view finance
		if(e.target.value == 'finance') {
			min_label = 'From';
			max_label = 'To';

			for(let i = 100; i < 2000; i += 100) {
				min_options += `<option value="${i}">${formatter.format(i)} per month</option>`;
				max_options += `<option value="${i + 100}">${formatter.format(i + 100)} per month</option>`;
			}
		} else { //otherwise we assume it's purchase
			for(let i = 1; i <= 100; i++) {
				min_options += `<option value="${i * 1000}">${formatter.format(i * 1000)}</option>`;
			}

			for(let i = 100; i > 0; i--) {
				max_options += `<option value="${i * 1000}">${formatter.format(i * 1000)}</option>`;
			}
		}

		$('#min').html('<option value="" default>' + min_label + '</option><option value="">' + (e.target.value == 'finance' ? 'No Minimum' : 'Any') + '</option>' + min_options);
		$('#max').html('<option value="" default>' + max_label + '</option><option value="">' + (e.target.value == 'finance' ? 'No Maximum' : 'Any') + '</option>' + max_options);
	});
});